export const ZERO_PRICE = {
  amount: 0,
  currency: '',
  taxAmount: 0,
  totalAmount: 0,
} as const

export const EMPTY_TIER = {
  period_from: 0,
  period_to: 0,
  price: ZERO_PRICE,
  max: 0,
} as const

export const DEFAULT_FULL_PREVIEW_INVOICE = {
  operation_type: '',
  operation_result: '',
  current_tier: EMPTY_TIER,
  current_state: EMPTY_TIER,
  current_total_state: EMPTY_TIER,
  new_tier: EMPTY_TIER,
  new_state: EMPTY_TIER,
  new_total_state: EMPTY_TIER,
  summary: {
    remaining_funds_until_billing_date: ZERO_PRICE,
    new_price_until_billing_date: ZERO_PRICE,
    amount_to_charge: ZERO_PRICE,
  },
} as const
